import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import genererModeCalculHonoraire from '@/services/devisCommandes/genererModeCalculHonorraire';

export default function genererLigneCommande(index) {
  const ligne = {
    ordre: null,
    produit: {
      reference: '',
    },
    produitId: null,
    tarif: null,
    libelle: null,
    quantite: null,
    uniteVente: null,
    prixUnitaire: null,
    totalAvantRemise: null,
    remise: null,
    typeRemise: null,
    tauxTva: null,
    totalHt: null,
    devisCommande: null,
    type: null,
    referencePersonnalise: null,
    dateDebut: null,
    dateFin: null,
    lignesRemise: [],
    masqueLigne: false,
    etatDeLaDemande: false,
    // La variable 'search' est utlisée pour la recherche dans l'autocomplet de la ligne de commande
    search: null,
    totalHtAvecLigneRemise: null,
    selected: false,
    fournisseur: null,
    fournisseurId: null,
    aFacturer: true,
    libelleFournisseur: null,
    modeCalculHonoraire: genererModeCalculHonoraire(),
    selectedLogistique: false,
    demandesLogistique: [],
    aIntegrerDansLaLogistique: true,
    ligneCommandeDispositif: null,
    lignesCmdSelOptionProduit: [],
    lieuxLivraisons: [],
  };
  if (index !== null) {
    ajoutOrdre(ligne, index);
  }
  return ligne;
}
